import {useEffect} from 'react';
import {getUserId, isUserPremium} from '@Libraries/user.library';
import {getCreditsCostForVideoBackgroundRemoval, getHashedIdWithStartAndEndTimeString} from '@Components/video-bg-removal-credits-cost/video-bg-removal-credits-cost-library';
import {useAppSelector} from '@/hooks';

export function useGetRemoveVideoBackgroundCreditsCost(hashedFilename: string, startTime: number, endTime: number): number | null {
  const userId = getUserId();

  const videoKey = getHashedIdWithStartAndEndTimeString(hashedFilename, startTime, endTime);
  const backgroundRemovalCreditsCostHashmap = useAppSelector((state) => {
    return state.videoBgRemovalCreditsCost;
  });

  useEffect((): void => {
    if (!isUserPremium()) {
      return;
    }

    if (userId && backgroundRemovalCreditsCostHashmap && backgroundRemovalCreditsCostHashmap[userId] && backgroundRemovalCreditsCostHashmap[userId][videoKey]) {
      return;
    }

    void getCreditsCostForVideoBackgroundRemoval(hashedFilename, startTime, endTime);
  });

  if (!userId) {
    return null;
  }

  if (!backgroundRemovalCreditsCostHashmap[userId]) {
    return null;
  }

  return backgroundRemovalCreditsCostHashmap[userId][videoKey] ?? null;
}
